export default function () {
    return function (input, key, filters) {

        for (var i = 0, l = input.length; i < l; i++) {
            if (input[i].career === filters[key] || filters[key] === 'Show all') {
                input[i].hiddenByProgramFilter = false;
            } else {
                input[i].hiddenByProgramFilter = true;
            }
        }
        return input;
    }
};